<template>
  <v-dialog v-model="dialog" persistent width="400px">
    <template v-slot:activator="{ on }">
      <v-btn
        small
        tile
        outlined
        depressed
        color="primary"
        dark
        v-on="on"
        @click="dialog = true"
        ><v-icon small color="primary">mdi-plus</v-icon>New Invoice Batch</v-btn
      >
    </template>

    <v-card>
      <validation-observer v-slot="{ invalid }">
        <v-card-title>New Invoice Batch</v-card-title>
        <v-card-text>
          <validation-provider :rules="{ required: true }" v-slot="{ errors }">
            <v-autocomplete
              v-model="programId"
              label="Program"
              :items="programs"
              item-text="name"
              item-value="programId"
              dense
              :error-messages="errors"
            ></v-autocomplete>
            <date-picker
              :value="batchDate"
              :field="{ label: 'Batch Date' }"
              @fieldChange="batchDate = $event"
              :validations="{ required: true }"
            ></date-picker>
          </validation-provider>
          <validation-provider :rules="{ required: true }" v-slot="{ errors }">
            <v-file-input
              v-model="selectedFile"
              prepend-icon="mdi-paperclip"
              label="Upload Report (xlsx)"
              accept=".xls, .xlsx"
              chips
              single-line
              :error-messages="errors"
            ></v-file-input>
          </validation-provider>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="clear"> Cancel </v-btn>
          <v-btn
            color="primary"
            outlined
            :dark="!invalid"
            :disabled="invalid"
            @click="createInvoiceBatch"
            >Create Invoice Batch
          </v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialog: false,
      programId: 6,
      batchDate: new Date(new Date().toDateString()),
      selectedFile: null,
    };
  },
  computed: {
    programs() {
      return this.$store.state.optionsModule.programs;
    },
  },
  methods: {
    async createInvoiceBatch() {
      this.dialog = false;
      this.$store.commit("uxModule/setShowLoader", true);
      let message = await this.$store.dispatch(
        "billingModule/createInvoiceBatch",
        {
          programId: this.programId,
          batchDate: this.batchDate,
          selectedFile: this.selectedFile,
        }
      );
      this.$store.commit("uxModule/setShowLoader", false);
      if (message) {
        this.$store.commit("uxModule/setSnackbarMsg", message);
        this.$store.commit("uxModule/setShowSnackbar", true);
      }
      this.clear();
    },
    clear() {
      this.programId = 6;
      this.batchDate = new Date(new Date().toDateString());
      this.selectedFile = null;
      this.dialog = false;
    },
  },
};
</script>
